/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type PaymentType = typeof PaymentType[keyof typeof PaymentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentType = {
  DUE: 'DUE',
  ACTUAL: 'ACTUAL',
  SAVINGS: 'SAVINGS',
} as const;
